export default "__VITE_ASSET__CK0876GU__"